import {
  AUTH_CHECK,
  CHANGE_PASSWORD,
  GET_PUBLIC_CERT,
  GUEST_SIGN_UP,
  LOGIN,
  LOGOUT,
  RECAPTCHA,
  RESET_PASSWORD,
  SEND_VERIFICATION_EMAIL,
  SIGN_UP,
  TOT,
  USER_ACCOUNT,
  VERIFY_EMAIL,
} from '@gameday/common/constants/endpoints'

export default {
  getPublicCert: GET_PUBLIC_CERT, // 'gamedayapi/auth/certs/public',
  getTot: TOT, // 'gamedayapi/account/tot',
  signin: LOGIN, // 'gamedayapi/account/signin',
  signup: SIGN_UP, // 'gamedayapi/account/signup',
  signout: LOGOUT, // 'gamedayapi/account/signout',
  signupGuest: GUEST_SIGN_UP, // 'gamedayapi/account/guestsignup',
  sendVerificationEmail: SEND_VERIFICATION_EMAIL, // 'gamedayapi/account/verificationemail',
  resetPassword: RESET_PASSWORD, // 'gamedayapi/account/resetpassword',
  verifyEmail: VERIFY_EMAIL, // 'gamedayapi/account/verifyemail',
  recaptcha: RECAPTCHA, // 'gamedayapi/common/recaptcha',
  changePassword: CHANGE_PASSWORD, // 'gamedayapi/account/changepassword',
  authCheck: AUTH_CHECK, // 'auth/check'
  getUserAccount: USER_ACCOUNT, // 'gamedayapi/user/account'
}
